import React, { useEffect, useState } from 'react';
import { Modal, Checkbox, Space, Button } from 'antd';

interface DownloadFieldsModalProps {
  visible: boolean;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: (selectedFields: string[]) => void;
  hiddenKeys?: string[]; // 新增：敏感字段隐藏键
}

const ALL_FIELDS: Array<{ key: string; label: string }> = [
  { key: 'container_code', label: '容器编码' },
  { key: 'location_code', label: '仓位编码' },
  { key: 'warehouse_code', label: '仓库代码' },
  { key: 'warehouse_name', label: '仓库名称' },
  { key: 'project_code', label: '项目编码' },
  { key: 'project_name', label: '项目名称' },
  { key: 'customer_username', label: '所属客户' },
  { key: 'operator_name', label: '操作人' },
  { key: 'put_away_time', label: '上架时间(ISO)' },
  { key: 'remarks', label: '备注' },
];

const DEFAULT_SELECTED = ALL_FIELDS.map(f => f.key);

const DownloadFieldsModal: React.FC<DownloadFieldsModalProps> = ({ visible, loading, onCancel, onConfirm, hiddenKeys }) => {
  const [selected, setSelected] = useState<string[]>(DEFAULT_SELECTED);

  useEffect(() => {
    if (visible) {
      // 打开时重置为默认全选
      setSelected(DEFAULT_SELECTED);
    }
  }, [visible]);

  // 过滤被隐藏的字段
  const filteredFields = Array.isArray(hiddenKeys) && hiddenKeys.length
    ? ALL_FIELDS.filter(f => !hiddenKeys.includes(f.key) && !(f.key === 'customer_username' && (hiddenKeys.includes('project__customer__username') || hiddenKeys.includes('container.project.customer') || hiddenKeys.includes('customer'))))
    : ALL_FIELDS;

  useEffect(() => {
    if (visible) {
      // 打开时将默认选择裁剪为不含被隐藏字段
      setSelected(DEFAULT_SELECTED.filter(k => filteredFields.find(f => f.key === k)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, hiddenKeys]);

  const allChecked = selected.length === filteredFields.length && filteredFields.length > 0;
  const indeterminate = selected.length > 0 && selected.length < filteredFields.length;

  return (
    <Modal
      title="选择下载字段"
      open={visible}
      confirmLoading={!!loading}
      onCancel={onCancel}
      onOk={() => onConfirm(selected)}
      okText="下载"
      cancelText="取消"
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ color: '#666' }}>请选择需要导出的字段（默认全选）</div>
          <div>
            <Checkbox
              indeterminate={indeterminate}
              checked={allChecked}
              onChange={(e) => {
                if (e.target.checked) setSelected(ALL_FIELDS.map(f => f.key));
                else setSelected([]);
              }}
            >
              全选
            </Checkbox>
            <Button type="link" onClick={() => setSelected([])} style={{ paddingLeft: 8 }}>
              清空
            </Button>
          </div>
        </div>
        <Checkbox.Group
          value={selected}
          onChange={(vals) => setSelected(vals as string[])}
          style={{ width: '100%' }}
        >
          <Space direction="vertical" size={8} style={{ width: '100%' }}>
            {filteredFields.map(field => (
              <Checkbox key={field.key} value={field.key}>
                {field.label}
              </Checkbox>
            ))}
          </Space>
        </Checkbox.Group>
      </Space>
    </Modal>
  );
};

export default DownloadFieldsModal;


